export const getEnvironmentDomain = (): string => {
	const { hostname } = window.location;

	return hostname.match(/(outofdark)\.\w*$/g)?.[0] ?? hostname;
};
